const Icons = {
  check: 'e900',
  checks: 'e901',
  activesessions: 'e902',
  add: 'e903',
  add_chat: 'e904',
  add_reaction: 'e905',
  addboost: 'e906',
  addmember_filled: 'e907',
  adduser: 'e908',
  admin: 'e909',
  ads: 'e90a',
  align_center: 'e90b',
  align_left: 'e90c',
  align_right: 'e90d',
  animals: 'e90e',
  animations: 'e90f',
  app_expand: 'e910',
  app_shrink: 'e911',
  archive: 'e912',
  arrow_down: 'e913',
  arrow_next: 'e914',
  arrow_prev: 'e915',
  arrow_up_circle_fill: 'e916',
  arrowcircle: 'e917',
  arrowhead: 'e918',
  attach: 'e919',
  audio_repeat: 'e91a',
  audio_repeat_single: 'e91b',
  author_hidden: 'e91c',
  avatarnext: 'e91d',
  avatarprevious: 'e91e',
  aversion: 'e91f',
  back: 'e920',
  binfilled: 'e921',
  bold: 'e922',
  bomb: 'e923',
  boost: 'e924',
  boostcircle: 'e925',
  bot_filled: 'e926',
  botcom: 'e927',
  bots: 'e928',
  brightness: 'e929',
  brush: 'e92a',
  bubblereply: 'e92b',
  bug: 'e92c',
  calendar: 'e92d',
  calendarfilter: 'e92e',
  camera: 'e92f',
  cameraadd: 'e930',
  captiondown: 'e931',
  captionup: 'e932',
  car: 'e933',
  card: 'e934',
  card_outline: 'e935',
  cash_circle: 'e936',
  channel: 'e937',
  channel_filled: 'e938',
  channelviews: 'e939',
  chatspinned: 'e93a',
  chatsplaceholder: 'e93b',
  check1: 'e93c',
  checkbox: 'e93d',
  checkboxblock: 'e93e',
  checkboxempty: 'e93f',
  checkboxon: 'e940',
  checklist_add: 'e941',
  checklist_done: 'e942',
  checklist_undone: 'e943',
  checkretract: 'e944',
  checkround: 'e945',
  checkround_filled: 'e946',
  clock: 'e947',
  close: 'e948',
  clouddownload: 'e949',
  collapse: 'e94a',
  colorize: 'e94b',
  comments: 'e94c',
  commentssticker: 'e94d',
  contrast: 'e94e',
  copy: 'e94f',
  crop: 'e950',
  cross: 'e951',
  crossgif: 'e952',
  crossround: 'e953',
  crossround_filled: 'e954',
  crossstar: 'e955',
  crown: 'e956',
  crown_outline: 'e957',
  crownalt: 'e958',
  crownoff: 'e959',
  crownoff_outline: 'e95a',
  darkmode: 'e95b',
  data: 'e95c',
  delete: 'e95d',
  delete_filled: 'e95e',
  deletedaccount: 'e95f',
  deleteleft: 'e960',
  deleteuser: 'e961',
  devices: 'e962',
  document: 'e963',
  dollar_circle: 'e964',
  dollar_circle_x: 'e965',
  down: 'e966',
  down_up: 'e967',
  download: 'e968',
  dragfiles: 'e969',
  dragmedia: 'e96a',
  eats: 'e96b',
  edit: 'e96c',
  email: 'e96d',
  endcall_filled: 'e96e',
  enhance: 'e96f',
  enter: 'e970',
  equalizer: 'e971',
  expand: 'e972',
  eye: 'e973',
  eye1: 'e974',
  eye2: 'e975',
  eyecross_outline: 'e976',
  factcheck: 'e977',
  fade: 'e978',
  fast_forward: 'e979',
  fast_rewind: 'e97a',
  favourites: 'e97b',
  flag: 'e97c',
  flip: 'e97d',
  flip_image_horizontal: 'e97e',
  folder: 'e97f',
  fontframe: 'e980',
  fontframe_bg: 'e981',
  fontframe_outline: 'e982',
  fontsize: 'e983',
  forward: 'e984',
  forward_filled: 'e985',
  free_transform: 'e986',
  fullscreen: 'e987',
  gc_microphone: 'e988',
  gc_microphoneoff: 'e989',
  gem: 'e98a',
  gem_exchange: 'e98b',
  gem_transfer: 'e98c',
  gem_transfer_outline: 'e98d',
  geometric_digit_0: 'e98e',
  geometric_digit_1: 'e98f',
  geometric_digit_2: 'e990',
  geometric_digit_3: 'e991',
  geometric_digit_4: 'e992',
  geometric_digit_5: 'e993',
  geometric_digit_6: 'e994',
  geometric_digit_7: 'e995',
  geometric_digit_8: 'e996',
  geometric_digit_9: 'e997',
  geometric_dot: 'e998',
  geometric_letter_x: 'e999',
  gifs: 'e99a',
  gift: 'e99b',
  gift_premium: 'e99c',
  grain: 'e99d',
  group: 'e99e',
  group_filled: 'e99f',
  group_star: 'e9a0',
  groupmedia: 'e9a1',
  groupmediaoff: 'e9a2',
  hand: 'e9a3',
  help: 'e9a4',
  hide: 'e9a5',
  highlights: 'e9a6',
  hourglass: 'e9a7',
  image: 'e9a8',
  image_original: 'e9a9',
  info: 'e9aa',
  info2: 'e9ab',
  italic: 'e9ac',
  key: 'e9ad',
  keyboard: 'e9ae',
  lamp: 'e9af',
  language: 'e9b0',
  largepause: 'e9b1',
  largeplay: 'e9b2',
  left: 'e9b3',
  limit_chat: 'e9b4',
  limit_chats: 'e9b5',
  limit_file: 'e9b6',
  limit_folders: 'e9b7',
  limit_link: 'e9b8',
  limit_pin: 'e9b9',
  link: 'e9ba',
  link_paid: 'e9bb',
  list: 'e9bc',
  listscreenshare: 'e9bd',
  livelocation: 'e9be',
  location: 'e9bf',
  lock: 'e9c0',
  lockoff: 'e9c1',
  loginlogodesktop: 'e9c2',
  loginlogomobile: 'e9c3',
  logout: 'e9c4',
  mac_command_key: 'e9c5',
  mediaspeed_empty: 'e9c6',
  mediaspoiler: 'e9c7',
  mediaspoileroff: 'e9c8',
  mention: 'e9c9',
  menu: 'e9ca',
  menu_feature_cover: 'e9cb',
  menu_feature_unique: 'e9cc',
  menu_verification: 'e9cd',
  message: 'e9ce',
  message_jump: 'e9cf',
  message_quote: 'e9d0',
  messageunread: 'e9d1',
  microphone: 'e9d2',
  microphone_crossed: 'e9d3',
  microphone_crossed_filled: 'e9d4',
  microphone_filled: 'e9d5',
  minus: 'e9d6',
  monospace: 'e9d7',
  more: 'e9d8',
  multistories: 'e9d9',
  mute: 'e9da',
  muted: 'e9db',
  mynotes: 'e9dc',
  newchannel: 'e9dd',
  newchannel_filled: 'e9de',
  newchat_filled: 'e9df',
  newgroup: 'e9e0',
  newgroup_filled: 'e9e1',
  newprivate: 'e9e2',
  newprivate_filled: 'e9e3',
  newtab: 'e9e4',
  next: 'e9e5',
  nochannel: 'e9e6',
  noncontacts: 'e9e7',
  nosound: 'e9e8',
  okay: 'e9e9',
  online: 'e9ea',
  passwordoff: 'e9eb',
  pause: 'e9ec',
  permissions: 'e9ed',
  person: 'e9ee',
  phone: 'e9ef',
  phone_filled: 'e9f0',
  pin: 'e9f1',
  pin2: 'e9f2',
  pinlist: 'e9f3',
  pinned_filled: 'e9f4',
  pinnedchat: 'e9f5',
  pip: 'e9f6',
  play: 'e9f7',
  playback_05: 'e9f8',
  playback_15: 'e9f9',
  playback_1x: 'e9fa',
  playback_2x: 'e9fb',
  plus: 'e9fc',
  plusround: 'e9fd',
  poll: 'e9fe',
  premium_addone: 'e9ff',
  premium_avatars: 'ea00',
  premium_badge: 'ea01',
  premium_colors: 'ea02',
  premium_double: 'ea03',
  premium_emoji: 'ea04',
  premium_filesize: 'ea05',
  premium_lastseen: 'ea06',
  premium_limits: 'ea07',
  premium_lock: 'ea08',
  premium_management: 'ea09',
  premium_noads: 'ea0a',
  premium_privacy: 'ea0b',
  premium_reactions: 'ea0c',
  premium_restrict: 'ea0d',
  premium_speed: 'ea0e',
  premium_status: 'ea0f',
  premium_stickers: 'ea10',
  premium_tags: 'ea11',
  premium_transcription: 'ea12',
  premium_translate: 'ea13',
  premium_unlock: 'ea14',
  premium_wallpaper: 'ea15',
  previous: 'ea16',
  promote: 'ea17',
  quote: 'ea18',
  quote_outline: 'ea19',
  radiooff: 'ea1a',
  radioon: 'ea1b',
  reactions: 'ea1c',
  reactions_filled: 'ea1d',
  readchats: 'ea1e',
  recent: 'ea1f',
  redo: 'ea20',
  reload_star: 'ea21',
  replace: 'ea22',
  reply: 'ea23',
  reply_filled: 'ea24',
  restrict: 'ea25',
  revenue: 'ea26',
  rightpanel: 'ea27',
  rotate: 'ea28',
  rotate_left: 'ea29',
  rotate_right: 'ea2a',
  round_chats_filled: 'ea2b',
  saturation: 'ea2c',
  saved: 'ea2d',
  savedmessages: 'ea2e',
  schedule: 'ea2f',
  scheduled: 'ea30',
  search: 'ea31',
  select: 'ea32',
  send: 'ea33',
  send2: 'ea34',
  sending: 'ea35',
  sendingerror: 'ea36',
  settings: 'ea37',
  settings_clipped_corner: 'ea38',
  settings_filled: 'ea39',
  shadows: 'ea3a',
  sharescreen_filled: 'ea3b',
  sharpen: 'ea3c',
  shipping: 'ea3d',
  shuffle: 'ea3e',
  smallscreen: 'ea3f',
  smile: 'ea40',
  sort_date: 'ea41',
  sort_num: 'ea42',
  sort_price: 'ea43',
  speaker: 'ea44',
  speakerfilled: 'ea45',
  speakeroff: 'ea46',
  speakerofffilled: 'ea47',
  spoiler: 'ea48',
  sport: 'ea49',
  star: 'ea4a',
  star_filled: 'ea4b',
  statistics: 'ea4c',
  stickers: 'ea4d',
  stickers_face: 'ea4e',
  stop: 'ea4f',
  stories: 'ea50',
  storyreply: 'ea51',
  storyrepost: 'ea52',
  strikethrough: 'ea53',
  suggested: 'ea54',
  tag: 'ea55',
  tag_add: 'ea56',
  tag_alt: 'ea57',
  tag_alt_crossed: 'ea58',
  tag_alt_outline: 'ea59',
  tag_crossed: 'ea5a',
  tag_filter: 'ea5b',
  tag_name: 'ea5c',
  text: 'ea5d',
  textedit: 'ea5e',
  time_lock: 'ea5f',
  timer: 'ea60',
  tip: 'ea61',
  ton: 'ea62',
  tools: 'ea63',
  topics: 'ea64',
  trade: 'ea65',
  transcribe: 'ea66',
  unarchive: 'ea67',
  unclaimed: 'ea68',
  underline: 'ea69',
  undo: 'ea6a',
  unmute: 'ea6b',
  unpack: 'ea6c',
  unpin: 'ea6d',
  unread: 'ea6e',
  up: 'ea6f',
  up_down: 'ea70',
  user: 'ea71',
  username: 'ea72',
  videocamera: 'ea73',
  videocamera_crossed_filled: 'ea74',
  videocamera_filled: 'ea75',
  videochat: 'ea76',
  vignette: 'ea77',
  volume_down: 'ea78',
  volume_mute: 'ea79',
  volume_off: 'ea7a',
  volume_up: 'ea7b',
  warmth: 'ea7c',
  warning: 'ea7d',
  webview: 'ea7e',
  win_key: 'ea7f',
  zoomin: 'ea80',
  zoomout: 'ea81'
};

export default Icons;
